import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  fieldWrapper: {
    marginBottom: 16,
  },
  fieldLabel: {
    fontSize: 13,
    // color: '#1E1E1E',
    color: '#374151',
    marginBottom: 6,
    fontFamily: 'OpenSans',
    fontWeight: '600',
    marginTop: 5,
    paddingHorizontal: 6,
    paddingTop: 6,
    paddingBottom: 4,
  },
  errorText: {
    fontSize: 12,
    color: '#900B09',
    fontWeight: '400',
    marginTop: 4,
  },
  required: {
    color: '#EC221F',
    fontSize: 16,
  },
});
